import { gql } from '@apollo/client';

export const UPSERT_MONITORINGFORMSUBMISSION = gql`
  mutation UpsertMonitoringFormSubmission($input: UpsertMonitoringFormSubmissionsInput!) {
    data: upsertMonitoringFormSubmission(input: $input) {
      id
    }
  }
`;
